export const trainKinds = [
  { id: 1, name: '普通', htmlClassName: 'local' },
  { id: 2, name: '区間快速Ａ', htmlClassName: 'com_r' },
  { id: 3, name: '区間快速Ｂ', htmlClassName: 'com_r' },
  { id: 4, name: '快速Ｂ', htmlClassName: 'rapid' },
  { id: 5, name: '快速Ａ', htmlClassName: 'rapid' },
  { id: 6, name: '新快速', htmlClassName: '' },
  { id: 7, name: '特別快速Ｂ', htmlClassName: '' },
  { id: 8, name: '特別快速Ａ', htmlClassName: '' },
  { id: 9, name: '団体', htmlClassName: '' },
  { id: 10, name: '回送１', htmlClassName: '' },
  { id: 11, name: '回送２', htmlClassName: '' },
  { id: 12, name: '試運転', htmlClassName: '' },
  { id: 13, name: '通勤快速Ａ', htmlClassName: 'semi_r' },
  { id: 14, name: '通勤快速Ｂ', htmlClassName: 'semi_r' },
  { id: 15, name: '通勤快速Ｃ', htmlClassName: 'semi_r' },
];

export function trainKindClass(id) {
  const trainKind = trainKinds.find(kind => kind.id === id);
  if (trainKind === undefined) {
    return '';
  }

  return trainKind.htmlClassName;
}
